var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloud(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1918 14.8393C10.4346 13.4828 11.1496 12.2545 12.2115 11.3697C13.2735 10.4849 14.6146 10 16 10C17.3854 10 18.7265 10.4849 19.7885 11.3697C20.8505 12.2545 21.5655 13.4828 21.8082 14.8393H21.8974C22.9855 14.8393 24.029 15.2692 24.7984 16.0344C25.5678 16.7996 26 17.8375 26 18.9197C26 20.0019 25.5678 21.0396 24.7984 21.8049C24.029 22.5701 22.9855 23 21.8974 23H10.1026C9.0145 23 7.97099 22.5701 7.20162 21.8049C6.43223 21.0396 6 20.0019 6 18.9197C6 17.8375 6.43223 16.7996 7.20162 16.0344C7.97099 15.2692 9.0145 14.8393 10.1026 14.8393H10.1918ZM16 11.5241C14.8817 11.524 13.8061 11.9514 12.9957 12.7179C12.1854 13.4843 11.7022 14.5313 11.6462 15.6421C11.6364 15.8383 11.5512 16.0231 11.4082 16.1585C11.2652 16.2939 11.0754 16.3694 10.8779 16.3695H10.1026C9.42252 16.3695 8.77033 16.6381 8.28947 17.1164C7.80861 17.5946 7.53846 18.2433 7.53846 18.9197C7.53846 19.596 7.80861 20.2446 8.28947 20.7229C8.77033 21.2011 9.42252 21.4699 10.1026 21.4699H21.8974C22.5775 21.4699 23.2297 21.2011 23.7105 20.7229C24.1914 20.2446 24.4615 19.596 24.4615 18.9197C24.4615 18.2433 24.1914 17.5946 23.7105 17.1164C23.2297 16.6381 22.5775 16.3695 21.8974 16.3695H21.1221C20.9245 16.3697 20.7344 16.2943 20.5911 16.1589C20.4479 16.0235 20.3626 15.8384 20.3528 15.6421C20.2968 14.5315 19.8137 13.4847 19.0036 12.7182C18.1935 11.9518 17.1181 11.5242 16 11.5241Z",
    fill: "url(#paint0_linear_3410_9314)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3410_9314",
    x1: 24.3778,
    y1: 10,
    x2: 17.4511,
    y2: 21.1838,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CAFEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AEB9EA"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/cloud.d6dfce16.svg";
export { ForwardRef as ReactComponent };